import PropTypes from 'prop-types'
import React from 'react'
import classes from '../Content.module.scss'

export class ContentTitle extends React.Component {
  static propTypes = {
    className: PropTypes.string
  }

  render () {
    let {
      className,

      children,

      ...restProps
    } = this.props

    let compClassName = classes.name
    if (className) compClassName += ' ' + className

    return (
      <div {...restProps} className={compClassName}>
        {children}
      </div>
    )
  }
}

export default ContentTitle
